export default "__VITE_ASSET__b5aad584__"